export default "__VITE_ASSET__BJsK_Ep___"